/* eslint-disable jsx-a11y/interactive-supports-focus */
import React from 'react';
import { useSelector } from 'react-redux';
import {
  maintenanceBannerDismissedSelector as dismissedMaintenanceSelector,
  geMaintenanceBannerDataSelector,
  expressPaxHomeV2AnnouncementBannerDataSelector as paxHomeSelector,
} from 'selectors/app-selector';
import { getActivePaxHomeBanner } from './banner-utils';
import MaintenanceBanner from './maintenance-banner/maintenance-banner';
import PaxHomeBanner from './pax-home-banner/pax-home-banner';

// Priority: Pax Home Banner (GE level) > Maintenance Banner (GE-web level)
// https://experiments.stg-myteksi.com/t/variables/expressPaxHomeV2AnnouncementBanner/rollout
// https://experiments.grab.com/t/variables/enableGeWebMaintenanceBanner/rollout
const NoticeBanner = () => {
  const expressPaxHomeV2AnnouncementBannerData = useSelector(paxHomeSelector);
  const notification = useSelector(geMaintenanceBannerDataSelector);
  const maintenanceBannerDismissed = useSelector(dismissedMaintenanceSelector);

  const activePaxHomeBanner = getActivePaxHomeBanner(
    expressPaxHomeV2AnnouncementBannerData,
  );

  if (activePaxHomeBanner) {
    return <PaxHomeBanner banner={activePaxHomeBanner} />;
  }

  if (notification) {
    return (
      <MaintenanceBanner
        notification={notification}
        maintenanceBannerDismissed={maintenanceBannerDismissed}
      />
    );
  }

  return null;
};

export default NoticeBanner;
